/* Absolute launch instant, independent of the visitor's timezone. */
(() => {
  if (window.phaseFiveCountdownInitialized) return;
  window.phaseFiveCountdownInitialized = true;
  function update() {
    document.querySelectorAll('[data-launch-countdown]').forEach(timer => {
      const end = Date.parse(timer.dataset.end);
      const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      if (!Number.isFinite(end) || remaining <= 0) {
        timer.hidden = true;
        timer.textContent = '';
        return;
      }
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      timer.textContent = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      timer.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds until the 2027 launch`);
      timer.hidden = false;
    });
  }
  update();
  window.setInterval(update, 1000);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', update);
})();
